<!-- Modal Compartir -->
<div class="modal fade" id="compartirModal" tabindex="-1" aria-labelledby="compartirModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="compartirModalLabel">Compartir perfil</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row mb-2">
          <div class="col">
            <input type="text" class="form-control" [value]="global.urlServer + 'perfil/' + slug" readonly>
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-sm" (click)="copiarSlug()"><i class="fa-regular fa-copy"></i></button>
          </div>
        </div>
        <div class="mb-2">
          <input type="text" class="form-control" placeholder="Buscar..." [(ngModel)]="textoBusqueda" (input)="filtrarAmigos()">
        </div>
        <div
          #scrollContainer
          class="small p-2 rounded bg-page-body justify-content-end"
          style="height: 50vh; overflow-y: auto; overflow-x: hidden;">
          <div class="row align-items-stretch">
            <div class="col-12 mb-2" *ngFor="let amigo of amigosFiltrados">
              <div class="w-100 p-2 rounded align-items-center" (click)="seleccionarAmigo(amigo)" [ngClass]="{'bg-white': !amigo.checked, 'bg-iguau text-white': amigo.checked}">
                <div class="d-flex pointer">
                  <div class="me-2 position-relative">
                    <div class="imagenes-montadas">
                      <img
                        *ngIf="amigo?.foto_mascota_thumb"
                        [src]="amigo?.foto_mascota_thumb"
                        class="rounded-circle pointer"
                        width="50"
                        [style.zIndex]="100">
                      <img 
                        [src]="amigo?.foto?.foto_principal_thumb"
                        class="rounded-circle pointer"
                        width="40"
                        [style.zIndex]="99"
                        >
                    </div>
                  </div>
                  <div class="w-100">
                    <div class="pointer">
                      {{amigo.mascota.ma_nombre | firstWord}} y {{amigo.first_name | firstWord}}
                      <div class="d-flex small">
                        <div class="me-1">
                          <span *ngIf="amigo.mascota.ma_sexo=='Macho'"><i class="fa-solid fa-mars"></i></span>
                          <span *ngIf="amigo.mascota.ma_sexo=='Hembra'"><i class="fa-solid fa-venus"></i></span>
                          {{amigo.mascota.ma_sexo}} {{amigo.mascota.edad}}
                        </div>
                        <div>
                          <span *ngIf="amigo.sexo=='Hombre'"><i class="fa-solid fa-mars"></i></span>
                          <span *ngIf="amigo.sexo=='Mujer'"><i class="fa-solid fa-venus"></i></span>
                          {{amigo.sexo}} {{amigo.edad}}
                        </div>
                      </div>
                      <div class="small" *ngIf="amigo.ciudad">{{amigo.ciudad}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="!loadingamigos && !(amigos && (amigos | keyvalue)?.length)">
            <div class="col">
              <div class="fw-bold">Aún no tienes amigos</div>
              <div class="text-secondary">Hora de sacar las patitas y saludar</div>
            </div>
          </div>
          <div *ngIf="loadingamigos" class="mt-3">
            <span class="spinner-border spinner-border-sm text-iguau" aria-hidden="true"></span>
            <span class="text-secondary ms-1">Cargando... </span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="compartirPerfil()">Compartir</button>
      </div>
    </div>
  </div>
</div>